import React, {useState, useRef, useEffect, useCallback} from 'react';

import styles from "./GameItem.module.css";
import RouterMgr from "@/Core/RouterMgr";
import Image from "next/image";
import {usePathname, useRouter, useSearchParams} from "next/navigation";

interface GameItemProps {
    data:any;
    // key:number;
}

const GameItem: React.FC<GameItemProps> = (props) => {
    const {data} = props;
    const {gameId,name} = data;
    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const [isVisible, setIsVisible] = useState(false);
    const bubbleRef = useRef<HTMLDivElement | null>(null);

    // 点击外部区域关闭提示框
    useEffect(() => {


    }, []);

    const onEnterGame = () => {
        // if (!UserMgr.isSignUpOK){
        //     SDialogManagerFC.openDialog(NotLoginDialogFC)
        //     return;
        // }
        RouterMgr.push(`/game?${createQueryString('game',gameId)}`);
    }

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )

    return (
        <div className={`${styles.item} btn`} onClick={onEnterGame}>
            <Image
                src={`/img/home/icon/game_${gameId}.webp`}
                alt={`game_${gameId}`}
                fill // 使用 fill 属性让图片填满容器
                style={{objectFit: 'cover'}}
                loading="lazy"
                placeholder={'blur'}
                blurDataURL="/img/imgLoad.svg"
            >
            </Image>
        </div>
    );
};

export default GameItem;
